//@ts-nocheck
import React from "react";

export default function Spinner(props) {
  const { color } = props;
  return (
    <div className={`spinner-border text-${color}`} role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
}
